import Model, { JsonArray } from 'src/models/model'

export default class ReportHtml extends Model {
  static name = 'ReportHtml'

  static define () {
    this.fields = {
      title: {
        type: String
      },
      html: {
        type: String
      },
      rawData: {
        type: JsonArray
      }
    }
  }
}
